var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaundry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.397,
    height: 22.5,
    viewBox: "0 0 19.397 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-laundry-5259520_1_",
    "data-name": "noun-laundry-5259520 (1)",
    transform: "translate(-131.25 -56.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247947",
    "data-name": "Path 247947",
    d: "M131.25,333.1a2.719,2.719,0,0,0,2.716,2.716h13.966a2.719,2.719,0,0,0,2.716-2.716V318.75h-19.4Zm9.7-12.8a5.826,5.826,0,1,1-4.113,1.707,5.82,5.82,0,0,1,4.113-1.707Zm-8.535-.776a.389.389,0,1,1-.274.114.388.388,0,0,1,.274-.114Zm-.388,1.94a.388.388,0,1,1,.776,0v3.879a.388.388,0,1,1-.776,0Z",
    transform: "translate(0 -257.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247948",
    "data-name": "Path 247948",
    d: "M582.026,506.638a.388.388,0,1,1-.388-.388.388.388,0,0,1,.388.388",
    transform: "translate(-440.69 -440.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247949",
    "data-name": "Path 247949",
    d: "M361.288,431.25a5.048,5.048,0,1,0,3.565,1.479,5.043,5.043,0,0,0-3.565-1.479Zm0,9.31a4.27,4.27,0,1,1,3.017-1.251,4.267,4.267,0,0,1-3.017,1.251Z",
    transform: "translate(-220.34 -367.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247950",
    "data-name": "Path 247950",
    d: "M450.389,526.97a.388.388,0,0,1-.339-.576,3.5,3.5,0,0,1,1.363-1.363.388.388,0,1,1,.377.678,2.725,2.725,0,0,0-1.062,1.061.387.387,0,0,1-.34.2Z",
    transform: "translate(-312.156 -459.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247951",
    "data-name": "Path 247951",
    d: "M454.947,640.294a3.49,3.49,0,0,1-6.63,1.525,3.529,3.529,0,0,1,3.138-1.137,4.162,4.162,0,0,0,3.414-1.121,3.51,3.51,0,0,1,.078.733Z",
    transform: "translate(-310.507 -571.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247952",
    "data-name": "Path 247952",
    d: "M148.707,56.25H133.19a1.94,1.94,0,0,0-1.94,1.94v2.716h19.4V58.19a1.94,1.94,0,0,0-1.94-1.94Zm-11.638,3.879h-3.1a.388.388,0,1,1,0-.776h3.1a.388.388,0,0,1,0,.776Zm0-1.552h-3.1a.388.388,0,1,1,0-.776h3.1a.388.388,0,0,1,0,.776Zm7.759.776a.388.388,0,1,1,.274-.114A.388.388,0,0,1,144.828,59.353Zm1.552,0a.388.388,0,1,1,.274-.114A.388.388,0,0,1,146.38,59.353Zm1.552,0a.388.388,0,1,1,.274-.114A.388.388,0,0,1,147.931,59.353Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundry);
export default __webpack_public_path__ + "static/media/laundry.3f24181ae54d85cad68152449973d2c8.svg";
export { ForwardRef as ReactComponent };